'use es6';

import { List } from 'immutable';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
export const ElasticsearchTextQueryClauseDelimiterRegex = /\s+OR\s+/gi;
// config via HubSpot/ElasticSearchUtils#281
export const queryClauseCountLimit = 500;
export const queryLengthLimit = 3000;
const FilterOperatorElasticsearchTextQueryInput = props => {
  const {
    className,
    error,
    onChange,
    value = List()
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const optionDelimiter = ' OR '; // must be all caps

  return /*#__PURE__*/_jsx(UIFormControl, {
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(UISelect, {
      allowCreate: value.size < queryClauseCountLimit,
      className: className,
      delimiter: optionDelimiter,
      maxLength: `${queryLengthLimit}`,
      menuWidth: "auto",
      multi: true,
      noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterOperatorMultiStringInput.resultsText"
      }),
      onChange: evt => {
        const {
          target: {
            value: nextValue
          }
        } = evt;
        return onChange({
          target: {
            value: List(nextValue)
          }
        });
      },
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterOperatorMultiStringInput.placeholder"
      }),
      splitRegex: ElasticsearchTextQueryClauseDelimiterRegex,
      value: value.toArray()
    })
  });
};
FilterOperatorElasticsearchTextQueryInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onChange: PropTypes.func.isRequired,
  value: ImmutablePropTypes.listOf(PropTypes.string).isRequired
};
export default FilterOperatorElasticsearchTextQueryInput;